/**
 * Form component for date of birth. Did not want to use a date picker because
 * that's painful UX. Uses react-input-mask to allow simply typing in MM/DD/YYYY
 * format. Not the best for international, but can be expanded later if needed. 
 * 
 * Validates date and checks against minimum age requirements.  
 * 
 * NOTE: Yote currently uses luxon for datetime management. ALL dates passed into
 * and out of date inputs MUST be epoch/unix time in milliseconds.  Makes things
 * agnostic on the parent components.
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import InputMask from 'react-input-mask';

// import components
import Base from '../../BaseComponent.js.jsx';

// import third party libraries
import classNames from 'classnames';
import { DateTime } from 'luxon';

class MonthYearInput extends Base {
  constructor(props) {
    super(props);
    this.state = {
      dateString: ''
      , errorMessage: ''
      , error: false 
      , val: this.props.value ? DateTime.fromMillis(this.props.value).toFormat('MM/yyyy') : null 
    };
    this._bind(
      '_handleInputChange'
    );
  }

  _handleInputChange(e) {
    const { allowFuture, minDate } = this.props;

    let now = DateTime.local().endOf('day');

    let date = DateTime.fromFormat(e.target.value, 'MM/yyyy').startOf('month');

    let error = false;
    let errorMessage = '';
    if(date.invalid) {
      error = true; 
      errorMessage = date.invalid.explanation
    } else if(!allowFuture && date > now) {
      error = true;
      errorMessage = "date cannot be in the future";
    } else if(minDate && date.startOf('month') < DateTime.fromMillis(minDate).startOf('month')) {
      error = true;
      errorMessage = "date must be after" + DateTime.fromMillis(minDate).toFormat('MM/yyyy');
    } 
    this.setState({
      dateString: !error ? date.toLocaleString(DateTime.DATE_MED) : ''
      , errorMessage
      , error
      , val: e.target.value
    })
    if(!error) {
      let event = { target: {}};
      event.target.name = this.props.name;
      event.target.value = date.toMillis();
      this.props.change(event);
    }
  }
  
  render() {
    const {
      change 
      , disabled
      , label
      , helpText
      , minDate
      , name
      , required
      , value 
    } = this.props;

    let inputClass = classNames(
      'field'
      , { "-error": this.state.error }
    );
    return (
      <div className="input-group">
        <label htmlFor={name}> {label} {required ? <sup className="-required">*</sup> : null}</label>
        <InputMask
          className={inputClass}
          mask="99/9999"
          onChange={this._handleInputChange}
          placeholder="MM/YYYY"
          value={this.state.val}
        />
        <div>
          <small className="help-text"><em>{helpText}</em></small>
        </div>
        <div>
          <small className="help-text"><em>{this.state.dateString}</em></small>
        </div>
        <div>
          <small className="-error-message"><em>{this.state.errorMessage}</em></small>
        </div>
      </div>
    )
  }
}

MonthYearInput.propTypes = {
  allowFuture: PropTypes.bool 
  , change: PropTypes.func.isRequired
  , disabled: PropTypes.bool
  , helpText: PropTypes.any
  , label: PropTypes.string 
  , minDate: PropTypes.number  // epoch/unix time in milliseconds
  , name: PropTypes.string.isRequired
  , required: PropTypes.bool
  , value: PropTypes.number  // epoch/unix time in milliseconds
}

MonthYearInput.defaultProps = {
  allowFuture: false 
  , disabled: false
  , helpText: null
  , label: '' 
  , minDate: null  
  , required: false
  , value: null 
}

export default MonthYearInput;



// WEBPACK FOOTER //
// global/components/forms/dates/MonthYearInput.js.jsx